export const COLLECTION_LANGUAGE_EN = 'en';
export const COLLECTION_LANGUAGE_DE = 'de';



// WEBPACK FOOTER //
// ./src/client/components/admin/collections/languages.js